import { render, staticRenderFns } from "./DbcdP.vue?vue&type=template&id=1aea0105"
import script from "./DbcdP.vue?vue&type=script&lang=js"
export * from "./DbcdP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports